// Définir la date cible en UTC (1er octobre 2024, 13:50 UTC soit 15:50 heure française)
const targetDateUTC = Date.UTC(2024, 9, 1, 13, 50); 

// Variable pour stocker si l'utilisateur est au Japon
let isJapan = false;

// Obtenir le pays de l'utilisateur via l'API ipapi.co
fetch('https://ipapi.co/json/')
  .then(response => response.json())
  .then(data => {
    if (data.country_code === 'JP') {
      isJapan = true;
    }
    // Après avoir déterminé si l'utilisateur est au Japon, procéder à la vérification et à la redirection si nécessaire
    checkAndRedirect();
  })
  .catch(error => {
    console.error('Erreur lors de la récupération des informations IP:', error);
    // En cas d'erreur, procéder à la redirection sans considérer le pays
    checkAndRedirect();
  });

// Fonction pour vérifier et rediriger si nécessaire
function checkAndRedirect() {
  // Obtenir la date actuelle
  const currentDate = new Date();

  // Si l'utilisateur n'est pas au Japon
  if (!isJapan) {
    // Vérifier si la date actuelle est inférieure à la date cible
    if (currentDate.getTime() < targetDateUTC) {
        // Rediriger vers l'URL spécifiée
        window.location.href = 'https://boutiquesalty.fr';
    }
  }
}
